module.exports = __webpack_public_path__ + "img/warning.a995c9df.png";